export var supportedLocales = ["en", "es", "cs", "ar", "he", "it", "pl", "ru", "uk", "de", "fr"];
export var formatCurrency = function (value) {
    if (value == null || !Number.isFinite(value))
        return "-";
    if (value === 0)
        return "0";
    var abs = Math.abs(value);
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        notation: abs >= 1000 ? "compact" : "standard",
        minimumFractionDigits: abs < 2 ? 4 : 2,
        maximumFractionDigits: abs < 2 ? 4 : 2,
    }).format(value);
};
export var getTrendColor = function (value) {
    return value > 0 ? "#00ff88" : "#ff5252";
};
export var formatChange = function (change) {
    return (change > 0 ? "+" : "") + change.toString();
};
export function createData(event, token, from, to, amount, price, time) {
    return { event: event, token: token, from: from, to: to, amount: amount, price: price, time: time };
}
export function getColorEvent(value) {
    if (value === "Sold" || value === "Accepted Offer") {
        return "#5fff5c;";
    }
    else if (value === "Canceled Offer" || value === "Canceled") {
        return " #ff6b6b";
    }
    else {
        return "white";
    }
}
export var shorten = function (addr) { return addr.slice(0, 6) + "..." + addr.slice(-4); };
export function filterTable(data, filterType) {
    if (filterType === "filterAll") {
        return data;
    }
    var filterMap = {
        filterListed: "Listed",
        filterSold: "Sold",
        filterMadeOffer: "Made Offer",
        filterAcceptedOffer: "Accepted Offer",
        filterCanceled: "Canceled",
        filterCanceledOffer: "Canceled Offer",
    };
    var eventType = filterMap[filterType];
    if (!eventType)
        return data;
    return data.filter(function (item) { return item.event === eventType; });
}
export var formatNFT = function (n) { return "".concat(n, " ").concat(n === 1 ? "NFT" : "NFTs"); };
export var validators = {
    website: function (v) { return /^https?:\/\/([a-z0-9-]+\.)+[a-z]{2,}(\/.*)?$/i.test(v); },
    instagram: function (v) {
        return /^https?:\/\/(www\.)?instagram\.com\/[A-Za-z0-9_.]+\/?(?:\?.*)?$/i.test(v);
    },
    discord: function (v) {
        return /^https?:\/\/(www\.)?(discord\.gg|discord\.gg\/users)\/[A-Za-z0-9]+\/?$/i.test(v);
    },
    twitter: function (v) {
        return /^https?:\/\/(www\.)?(twitter\.com|x\.com)\/[A-Za-z0-9_]+\/?(?:\?.*)?$/i.test(v);
    },
    telegram: function (v) { return /^https?:\/\/(www\.)?t\.me\/[A-Za-z0-9_]+\/?$/i.test(v); },
    reddit: function (v) { return /^https?:\/\/(www\.)?reddit\.com\/(u|user)\/[A-Za-z0-9_-]+\/?$/i.test(v); },
    nickname: function (v) { return /^[A-Za-z0-9_\-\u0400-\u04FF]{1,30}$/.test(v); },
    username: function (v) { return /^[A-Za-z0-9_-]{1,20}$/.test(v); },
};
